export function seasonFromDate(date) {
  const month = Number(date?.slice(5, 7));
  if (!month || month > 12) return '';
  if (month >= 3 && month <= 5) return 'spring';
  if (month >= 6 && month <= 8) return 'summer';
  if (month >= 9 && month <= 11) return 'fall';
  return 'winter';
}

export function localToday() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function resolveHarvestCategory(species, config) {
  const category = config?.speciesCategoryAssignments?.[species.speciesId]?.category
    || (species.speciesCategory === 'Fish' ? 'fishing' : species.harvestCategory) || Object.entries(config?.speciesCategoryMap || {})
    .find(([name]) => name.toLowerCase() === species.speciesName?.toLowerCase())?.[1];
  return config?.categories?.some((entry) => entry.key === category) ? category : '';
}
